import React from "react";
import { useModalAddPaymentMethodHook } from "./modal-add-payment-method-hooks";

type ContextModalAddPaymentMethod = ReturnType<
  typeof useModalAddPaymentMethodHook
>;
export const ModalAddPaymentMethodContext =
  React.createContext<ContextModalAddPaymentMethod | null>(null);

export function useContextModalAddPaymentMethod() {
  const context = React.useContext(ModalAddPaymentMethodContext);

  if (!context) {
    throw new Error(
      "useContextModalAddPaymentMethod must be used within a ContextModalAddPaymentMethodProvider",
    );
  }

  return context;
}
